import { GoogleGroupGroupTypes, GoogleGroupMemberMode, GoogleGroupWhoCanJoin, GoogleGroupWhoCanModerateMembers, GoogleGroupWhoCanPostMessage, GoogleGroupWhoCanViewGroup, GoogleGroupWhoCanViewMemberShip } from '../../../../../../models/CoreGoogleGroupModels';

export const groupTypes: GoogleGroupGroupTypes[] = [
    GoogleGroupGroupTypes.Classes,
    GoogleGroupGroupTypes.ClassStudentMember,
    GoogleGroupGroupTypes.SubjectOrCourse,
    GoogleGroupGroupTypes.MentorGroup,
    GoogleGroupGroupTypes.TeacherOwnerStudentMember,
    GoogleGroupGroupTypes.TeacherMember,
    GoogleGroupGroupTypes.StudentMember,
    GoogleGroupGroupTypes.StaffMember,
    GoogleGroupGroupTypes.StaffAndTeacherOwnerStudentMember,
];

export const ownerMode: GoogleGroupMemberMode[] = [
    GoogleGroupMemberMode.STRICT,
    GoogleGroupMemberMode.PERMISSIVE
];

export const memberMode: GoogleGroupMemberMode[] = [
    GoogleGroupMemberMode.STRICT,
    GoogleGroupMemberMode.PERMISSIVE
];

export const whoCanViewMemberShip: GoogleGroupWhoCanViewMemberShip[] = [
    GoogleGroupWhoCanViewMemberShip.AllInDomain,
    GoogleGroupWhoCanViewMemberShip.AllMembers,
    GoogleGroupWhoCanViewMemberShip.AllManagers
];

export const whoCanPostMessage: GoogleGroupWhoCanPostMessage[] = [
    GoogleGroupWhoCanPostMessage.AllManagers,
    GoogleGroupWhoCanPostMessage.AllMembers,
    GoogleGroupWhoCanPostMessage.AllOwners,
    GoogleGroupWhoCanPostMessage.AllInDomain,
    GoogleGroupWhoCanPostMessage.Anyone
];

export const whoCanModerateMembers: GoogleGroupWhoCanModerateMembers[] = [
    GoogleGroupWhoCanModerateMembers.AllMembers,
    GoogleGroupWhoCanModerateMembers.OwnersAndManagers,
    GoogleGroupWhoCanModerateMembers.OwnersOnly,
    GoogleGroupWhoCanModerateMembers.None
];

export const whoCanJoin: GoogleGroupWhoCanJoin[] = [
    GoogleGroupWhoCanJoin.Anyone,
    GoogleGroupWhoCanJoin.AllInDomain,
    GoogleGroupWhoCanJoin.Invited,
    GoogleGroupWhoCanJoin.RequestToJoin
];

export const whoCanViewGroup: GoogleGroupWhoCanViewGroup[] = [
    GoogleGroupWhoCanViewGroup.Anyone,
    GoogleGroupWhoCanViewGroup.AllInDomain,
    GoogleGroupWhoCanViewGroup.AllMembers,
    GoogleGroupWhoCanViewGroup.AllManagers,
    GoogleGroupWhoCanViewGroup.AllOwners
];
